import React, { Component } from "react";
import {
  CardWrapper,
  PreviewVideo,
  Thumbnail,
  ThumbnailWrap,
  TitleHover,
  Title,
  Date,
  EditableIcon,
  PremiumIcon,
  IconGroup,
  NewTagIcon
} from "./Card.style";
import dayjs from 'dayjs'
import { connect } from 'react-redux';

class Card extends Component {

  state = {
    isHovered: false,
    isPlaying: false
  }

  handleVideoTimeUpdate = () => this.setState({ isPlaying: true })

  handleMouseEnter = () => this.setState({ isHovered: true })
  handleMouseLeave = () => this.setState({ isHovered: false, isPlaying: false })

  render() {
    const { isHovered, isPlaying } = this.state
    const {
      previewUrl,
      thumbnailUrl,
      title,
      date,
      onThumbnailClicked,
      isEditable,
      isPremium,
      cardSize = undefined,
      isNewTemplate
    } = this.props;
    return (
      <CardWrapper>
        {isNewTemplate ? <NewTagIcon /> : null}
        <ThumbnailWrap {...cardSize} notThumbnailUrl={!thumbnailUrl} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
          {
            isHovered &&
            <PreviewVideo 
              src={previewUrl}
              muted
              autoPlay
              loop
              onTimeUpdate={this.handleVideoTimeUpdate}
            />
          }
          <Thumbnail
            src={thumbnailUrl ? thumbnailUrl : ""}
            onClick={onThumbnailClicked}
            notThumbnailUrl={!thumbnailUrl}
            isHide={isHovered && isPlaying}
          />
          <IconGroup>
            {isEditable && <EditableIcon src="https://front.videomonster.com/images-7cuytg20/web/editableIcon.svg" alt="editable-icon" />}
            {isPremium && <PremiumIcon src="https://front.videomonster.com/images-7cuytg20/web/premiumIcon.svg" alt="premium-icon" />}
          </IconGroup>
          <TitleHover>
            <Title>{title}</Title>
            <Date>{`${dayjs(date).year()}.${dayjs(date).month() + 1}.${dayjs(date).date()}`}</Date>
          </TitleHover>
        </ThumbnailWrap>
      </CardWrapper>
    );
  }
}

const mapStateToProps = state => ({
  value: state.langStore.lang
})

export default connect(
  mapStateToProps,
  null
)(Card)